import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { PreavisInterventionState, state } from './state';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

const module: Module<PreavisInterventionState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { PreavisInterventionState };
